export default "__VITE_ASSET__17a84b37__"